
class UserService { 

  constructor(userData) {
    this.userData = userData;
  }

  get(key) {
    return this.userData[key];
  }

  hasRole(role) {
    return this.get('roles').includes(role);
  }

  isSupplier() {
    if (this.get('usergroup') == 3) return true;
    return false;
  }

  isCoordinator() {
    if (this.get('usergroup') == 1) return true;
    return false;
  }

  isCustomer() {
    if (this.get('usergroup') == 4) return true;
    return false;
  }
  
  isAgency() {
    if (this.get('isAgency') == 1) return true;
    return false;
  }

  getDashboardPath() {
    if (this.isSupplier()) return 'supplierdashboard';
    if (this.isCustomer()) return 'customerdashboard';
    return 'coordinatordashboard';
  }

}

module.exports = UserService;